export abstract class ReducerBase<T> {

    private handlers: any = {};

    addHandler(name: string, handler: any) {
        this.handlers[name] = handler;
    }

    handleEvent(state: T, action: Event) {
        const handler = this.handlers[action.type];

        if (handler == null) return this.handleDefault(state);
        return handler(state, action);
    }

    abstract handleDefault(state: T): T;
}